import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["totalItems", "activePage", "itemsPerPage", "itemsPerPageList", "onChangePage", "onChangeItemsPerPage", "amountAdjacentItems", "locale", "menuPlacement", "classes"];
import React, { createContext } from 'react';
import classNames from 'classnames/bind';
import { Pages } from "./components/Pages";
import { Results } from "./components/Results";
import { Select } from "./components/Select/Select";
import { clearValue, defaultChangeHandler } from "./helpers";
import { usePageNavigator } from "./usePageNavigator";
import { defaultPropObject } from "../constants";
import styles from "./PageNavigator.css";
var cx = classNames.bind(styles);
export var PageNavigatorContext = /*#__PURE__*/createContext({
  activePage: 0,
  totalItems: 0,
  onChangePage: defaultChangeHandler,
  locale: 'ru',
  itemsPerPage: 0
});
export var PageNavigator = function PageNavigator(_ref) {
  var totalItems = _ref.totalItems,
      activePage = _ref.activePage,
      itemsPerPage = _ref.itemsPerPage,
      itemsPerPageList = _ref.itemsPerPageList,
      _ref$onChangePage = _ref.onChangePage,
      onChangePage = _ref$onChangePage === void 0 ? defaultChangeHandler : _ref$onChangePage,
      _ref$onChangeItemsPer = _ref.onChangeItemsPerPage,
      onChangeItemsPerPage = _ref$onChangeItemsPer === void 0 ? defaultChangeHandler : _ref$onChangeItemsPer,
      _ref$amountAdjacentIt = _ref.amountAdjacentItems,
      amountAdjacentItems = _ref$amountAdjacentIt === void 0 ? 1 : _ref$amountAdjacentIt,
      _ref$locale = _ref.locale,
      locale = _ref$locale === void 0 ? 'ru' : _ref$locale,
      _ref$menuPlacement = _ref.menuPlacement,
      menuPlacement = _ref$menuPlacement === void 0 ? 'bottom' : _ref$menuPlacement,
      _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? defaultPropObject : _ref$classes,
      rest = _objectWithoutProperties(_ref, _excluded);

  var paginationRange = usePageNavigator({
    activePage: activePage,
    totalItems: totalItems,
    amountAdjacentItems: amountAdjacentItems,
    itemsPerPage: itemsPerPage
  });

  var handleKeyPress = function handleKeyPress(e) {
    var pageIncludedInRage = Number(e.currentTarget.value) <= Math.ceil(totalItems / itemsPerPage) && Number(e.currentTarget.value) > 0;

    if (e.key === 'Enter') {
      if (pageIncludedInRage) {
        onChangePage(Number(e.currentTarget.value));
        clearValue(e);
      }
    }
  };

  var handleBlur = function handleBlur(e) {
    clearValue(e);
  };

  return /*#__PURE__*/React.createElement("nav", _extends({}, rest, {
    className: cx('root')
  }), /*#__PURE__*/React.createElement(PageNavigatorContext.Provider, {
    value: {
      activePage: activePage,
      totalItems: totalItems,
      itemsPerPage: itemsPerPage,
      onChangePage: onChangePage,
      locale: locale
    }
  }, /*#__PURE__*/React.createElement(Results, null), /*#__PURE__*/React.createElement(Pages, {
    paginationRange: paginationRange,
    handleBlur: handleBlur,
    handleKeyPress: handleKeyPress,
    pagesFieldClassName: classes === null || classes === void 0 ? void 0 : classes.pagesField
  }), /*#__PURE__*/React.createElement(Select, {
    items: itemsPerPageList,
    itemsPerPage: itemsPerPage,
    onSelect: onChangeItemsPerPage,
    menuPlacement: menuPlacement
  })));
};
export default PageNavigator;